export function getConnectionLabel(connected: boolean): string {
  return connected ? 'Ja' : 'Nein';
}

export function normalizeTestMessage(message?: string): string {
  if (!message) return 'Kein Testergebnis vorhanden';
  return message.trim();
}
